// extracted by mini-css-extract-plugin
module.exports = {"root":"BucketFill_root__vz9EA","ignoreFill":"BucketFill_ignoreFill__DGgW8"};